import { Order, TPayment } from '@Arti-zen/package-backoffice'
import { EPaymentProgressStatus, TPaymentExtended } from '../../store/store.facturation.interfaces'
import { DateTime } from 'luxon'

export const filterPaymentList = ({
  paymentOrphanList,
  textSearched,
  dateStart,
  dateEnd,
  paymentStatusList,
}: {
  paymentOrphanList: TPaymentExtended[]
  textSearched: string
  dateStart: DateTime | null
  dateEnd: DateTime | null
  paymentStatusList: EPaymentProgressStatus[]
}) => {
  return paymentOrphanList.filter((payment) => {
    const searchTest = textSearched
      ? [
          String(payment?.artisan?.id).includes(textSearched),
          payment?.artisan?.email.includes(textSearched),
          payment?.GCLid.includes(textSearched),
        ].some((test) => test === true)
      : true

    return [
      searchTest,
      dateStart ? dateStart.startOf('day').diff(payment.chargeDateTime, 'milliseconds').milliseconds < 0 : true,
      dateEnd ? dateEnd.endOf('day').diff(payment.chargeDateTime, 'milliseconds').milliseconds > 0 : true,
      paymentStatusList.includes(payment.paymentProgress),
    ].every((test) => test === true)
  })
}

export const sortPaymentList = ({
  paymentList,
  activeSort,
}: {
  paymentList: TPaymentExtended[]
  activeSort: { key: keyof TPayment; order: Order }[]
}) => {
  console.log('activeSort', activeSort[0])


  return paymentList.sort((a, b) => {
    const { key, order } = activeSort[0]
    console.log(a[key], b[key])

    if (order === Order.ASC) {
      return +a[key] < +b[key] ? -1 : 1
    } else {
      return +a[key] > +b[key] ? -1 : 1
    }
  })
}

export const statusListReducer = (state: EPaymentProgressStatus[], action: EPaymentProgressStatus) => {
  if (state.includes(action)) {
    return state.filter((state) => state !== action)
  } else {
    return [...state, action]
  }
}
